"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ArduinoPlusMinus: ['arduino-plus-minus', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.5,6.283c-3.3,0-5.582,3.149-6.5,4.683-.918-1.534-3.2-4.683-6.5-4.683A5.428,5.428,0,0,0,0,12a5.427,5.427,0,0,0,5.5,5.718c3.3,0,5.582-3.149,6.5-4.684.918,1.535,3.2,4.684,6.5,4.684A5.427,5.427,0,0,0,24,12,5.428,5.428,0,0,0,18.5,6.283Zm1,6.185H19a.25.25,0,0,0-.25.25v.5a.75.75,0,0,1-1.5,0v-.5a.25.25,0,0,0-.25-.25h-.5a.75.75,0,0,1,0-1.5H17a.25.25,0,0,0,.25-.25v-.5a.75.75,0,0,1,1.5,0v.5a.25.25,0,0,0,.25.25h.5a.75.75,0,0,1,0,1.5Zm-12.5,0H4.5a.75.75,0,0,1,0-1.5H7a.75.75,0,0,1,0,1.5Z']],
  ArduinoPlusMinus1: ['arduino-plus-minus-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,10a1.509,1.509,0,0,0-.6-1.2L22,7.751V3.5A1.5,1.5,0,0,0,20.5,2H1.5A1.5,1.5,0,0,0,0,3.5v17A1.5,1.5,0,0,0,1.5,22h19A1.5,1.5,0,0,0,22,20.5v-2.25l1.4-1.05A1.508,1.508,0,0,0,24,16ZM19.125,11.94a3.684,3.684,0,0,1-2.728,3.6c-2.289.577-3.961-1.1-4.819-2.276a.25.25,0,0,0-.406,0c-.858,1.174-2.53,2.853-4.819,2.276a3.684,3.684,0,0,1-2.728-3.6A3.53,3.53,0,0,1,7.277,8.348a5.134,5.134,0,0,1,3.9,2.394.25.25,0,0,0,.406,0,5.134,5.134,0,0,1,3.9-2.394A3.53,3.53,0,0,1,19.125,11.94Z', 'M6,12a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,0-1h-2A.5.5,0,0,0,6,12Z', 'M15.5,10.5a.5.5,0,0,0-.5.5v.25a.25.25,0,0,1-.25.25H14.5a.5.5,0,0,0,0,1h.25a.25.25,0,0,1,.25.25V13a.5.5,0,0,0,1,0v-.25a.25.25,0,0,1,.25-.25h.25a.5.5,0,0,0,0-1h-.25a.25.25,0,0,1-.25-.25V11A.5.5,0,0,0,15.5,10.5Z']],
  ArduinoPlusMinusAlternate: ['arduino-plus-minus-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.217,6.218c-2.952,0-5.093,2.307-6.217,3.889C10.876,8.525,8.735,6.218,5.783,6.218A5.593,5.593,0,0,0,0,12a5.594,5.594,0,0,0,5.783,5.783c2.952,0,5.093-2.307,6.217-3.89,1.124,1.583,3.265,3.89,6.217,3.89A5.594,5.594,0,0,0,24,12,5.593,5.593,0,0,0,18.217,6.218ZM5.783,15.784A3.62,3.62,0,0,1,2,12,3.62,3.62,0,0,1,5.783,8.218c2.527,0,4.408,2.69,5.068,3.781C10.188,13.084,8.288,15.784,5.783,15.784Zm12.434,0c-2.527,0-4.408-2.69-5.068-3.781.663-1.086,2.563-3.785,5.068-3.785A3.62,3.62,0,0,1,22,12,3.62,3.62,0,0,1,18.217,15.784Z', 'M7.5,10.968h-3a.75.75,0,0,0,0,1.5h3a.75.75,0,0,0,0-1.5Z', 'M19.5,10.968H19a.25.25,0,0,1-.25-.25v-.5a.75.75,0,0,0-1.5,0v.5a.25.25,0,0,1-.25.25h-.5a.75.75,0,0,0,0,1.5H17a.25.25,0,0,1,.25.25v.5a.75.75,0,0,0,1.5,0v-.5a.25.25,0,0,1,.25-.25h.5a.75.75,0,0,0,0-1.5Z']],
  ArduinoCircuit: ['arduino-circuit', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,10a1.509,1.509,0,0,0-.6-1.2l-1.3-.974a.252.252,0,0,1-.1-.2V3.5A1.5,1.5,0,0,0,20.5,2H1.5A1.5,1.5,0,0,0,0,3.5v17A1.5,1.5,0,0,0,1.5,22h19A1.5,1.5,0,0,0,22,20.5V18.376a.249.249,0,0,1,.1-.2l1.3-.975A1.508,1.508,0,0,0,24,16ZM13.5,18.5a.25.25,0,0,0-.25.25V19a.75.75,0,0,1-1.5,0v-.25a.25.25,0,0,0-.25-.25H10a.25.25,0,0,0-.25.25V19a.75.75,0,0,1-1.5,0v-.25A.25.25,0,0,0,8,18.5H7a.5.5,0,0,1-.5-.5V15a.5.5,0,0,1,.5-.5H8a.25.25,0,0,0,.25-.25V14a.75.75,0,1,1,1.5,0v.25a.25.25,0,0,0,.25.25h1.5a.25.25,0,0,0,.25-.25V14a.75.75,0,1,1,1.5,0v.25a.25.25,0,0,0,.25.25H15a.25.25,0,0,0,.25-.25V14a.75.75,0,1,1,1.5,0v.25a.25.25,0,0,0,.25.25h1a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5H17a.25.25,0,0,0-.25.25V19a.75.75,0,1,1-1.5,0v-.25A.25.25,0,0,0,15,18.5ZM6,8.751V6a1.251,1.251,0,0,1,1.25-1.25H10A1.251,1.251,0,0,1,11.25,6v2.75A1.252,1.252,0,0,1,10,10H7.25A1.252,1.252,0,0,1,6,8.751ZM14.25,8a1,1,0,1,1-1,1A1,1,0,0,1,14.25,8Zm-1-2.25a1,1,0,1,1,1,1A1,1,0,0,1,13.25,5.751ZM17.75,10a1,1,0,1,1,1-1A1,1,0,0,1,17.75,10Zm0-3.25a1,1,0,1,1,1-1A1,1,0,0,1,17.75,6.751Z', 'M7.500 6.251 L9.750 6.251 L9.750 8.501 L7.500 8.501 Z']],
  ArduinoPlusMinus1Alternate: ['arduino-plus-minus-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,10a2.009,2.009,0,0,0-.8-1.6L22,7.5v-4a2,2,0,0,0-2-2H2a2,2,0,0,0-2,2v17a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2v-2l1.2-.9A2.009,2.009,0,0,0,24,16Zm-2,6-1.6,1.2a1,1,0,0,0-.4.8v2a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,20V4a.5.5,0,0,1,.5-.5h17A.5.5,0,0,1,20,4V8a1,1,0,0,0,.4.8L22,10Z', 'M19.125,12.062a3.684,3.684,0,0,0-2.728-3.6c-2.289-.577-3.961,1.1-4.819,2.276a.25.25,0,0,1-.406,0c-.858-1.175-2.53-2.853-4.819-2.276a3.684,3.684,0,0,0-2.728,3.6,3.529,3.529,0,0,0,3.652,3.591,5.136,5.136,0,0,0,3.9-2.393.249.249,0,0,1,.406,0,5.136,5.136,0,0,0,3.9,2.393A3.529,3.529,0,0,0,19.125,12.062ZM15.5,13.5A.5.5,0,0,1,15,13v-.25a.25.25,0,0,0-.25-.25H14.5a.5.5,0,0,1,0-1h.25a.25.25,0,0,0,.25-.25V11a.5.5,0,1,1,1,0v.25a.25.25,0,0,0,.25.25h.25a.5.5,0,0,1,0,1h-.25a.25.25,0,0,0-.25.25V13A.5.5,0,0,1,15.5,13.5ZM9,12a.5.5,0,0,1-.5.5h-2a.5.5,0,1,1,0-1h2A.5.5,0,0,1,9,12Z']]
};
exports["default"] = _default;